<template>
    <div
        v-click-outside="handleOutsideClick"
        :class="[{ show }, 'dropdown']"
    >
        <button
            @click="show = !show"
            type="button"
            class="dropdown-handle"
        >
            <slot name="handle" />
        </button>
        <transition name="slide-fade">
            <div
                v-if="show"
                :class="`dropdown-panel align-${align}`"
            >
                <slot/>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'Dropdown',
        props: {
            align: {
                type: String,
                default: 'left',
            },
        },
        data() {
            return {
                show: false,
            };
        },
        methods: {
            handleOutsideClick() {
                this.show = false;
            },
        },
    };
</script>

<style lang="scss">
    .dropdown {
        position: relative;
        z-index: 100;

        &.show {
            z-index: 101;

            .dropdown-handle .icon-arrow-down {
                transform: scaleY(-1);
            }
        }

        &-panel {
            position: absolute;
            top: 100%;
            left: 0;
            width: 280px;
            margin-top: 8px;
            overflow: hidden;
            background: #fff;
            border-radius: 4px;
            box-shadow: 0 0 48px rgba(#000, 0.15);

            &.align-right {
                right: 0;
                left: auto;
                margin-right: -8px;
                margin-left: 0;
            }

            &-hidden {
                .dropdown:not(.show) & {
                    @include visually-hidden;
                }
            }
        }

        &-handle .btn:not(.btn-symbol) .icon-chevron-down {
            font-size: 10px;
            transition: transform 0.3s;
        }
    }
</style>
